import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { useDispatch } from "react-redux";
import LoginForm from "../components/Login";
import { login } from "../store/actions";
import useForm from "../../../core/hooks/useForm";
import LoginModel from "../models/login";
import { LoginForm as LoginConstant } from "../constants";
import { useAppSelector } from "@utils/reduxUtil";

const INITIAL_STATE = cloneDeep(LoginModel);

const Login = React.memo(function Login(props: any) {
	const { handleChange, handleBlur, controls, handleSubmit } = useForm(INITIAL_STATE) as any;
	const dispatch = useDispatch();

	const handleSubmitChange = () => {
		const isValid = handleSubmit();
		if (isValid) {
			dispatch(login(controls[LoginConstant.USERNAME].value, controls[LoginConstant.PASSWORD].value) as any);
		}
	};

	// Subscribing store for token
	const authData = useAppSelector((state) => state.auth);
	const { error } = authData;

	return (
		<LoginForm
			handleSubmit={handleSubmitChange}
			handleChange={handleChange}
			handleBlur={handleBlur}
			controls={controls}
			error={error}
		/>
	);
});
export default Login;
